<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M1.83,782.5c1.39,0,2.5,1.12,2.5,2.5v10.01c1.05,0.79,1.67,2.02,1.67,3.33c0,2.3-1.87,4.17-4.17,4.17
	c-2.3,0-4.17-1.87-4.17-4.17c0-1.31,0.62-2.54,1.67-3.33V785C-0.67,783.62,0.45,782.5,1.83,782.5z M2.67,790H1v5.98
	c-1,0.35-1.67,1.29-1.67,2.35c0,1.38,1.12,2.5,2.5,2.5c1.38,0,2.5-1.12,2.5-2.5c0-1.06-0.67-2-1.67-2.35V790z M-2.33,790.83h-3.33
	v1.67h3.33V790.83z M-2.33,786.67h-3.33v1.67h3.33V786.67z"/>
</svg>

</template>